export default __webpack_public_path__ + "static/media/icon-mail-hosting.183db6a4.svg";